import React, { useContext } from 'react';

import styled from 'styled-components';

import { CommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';
import LinearGradientDivider from 'components/lib/LinearGradientDivider';

const Container = styled.div`
  margin-top: 15px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const RowLabel = styled.p`
  color: var(--text-primary);
  font-family: var(--font-bold);
  width: 50%;
`;

const Dot = styled.div`
  width: 5px;
  height: 5px;
  background-color: var(--text-secondary);
  border-radius: 50%;
  margin-top: -8px;
`;

const LabelWrapper = styled.div`
  margin-top: 5px;
`;

const LabelsRow = styled.div`
  display: flex;
  margin-top: 5px;
`;

const PercentagesRow = styled.div`
  display: flex;
`;

const Column = styled.div`
  flex: 1;
`;

const Label = styled.div`
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
`;

const Percentages = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const BasicInfoLifePlanDetails = () => {
  const { communityInfo } = useContext(CommunityInfoContext);
  const contracts = (communityInfo?.contracts || []).filter((contract) => contract.type !== 1);

  // Group by contract type
  const typeMap = new Map<number, { name: string; percentages: number[] }>();

  contracts.forEach((contract) => {
    if (!typeMap.has(contract.type)) {
      typeMap.set(contract.type, {
        name: contract.name,
        percentages: [contract.refund_percentage],
      });
    } else {
      typeMap.get(contract.type)!.percentages.push(contract.refund_percentage);
    }
  });

  if (typeMap.size === 0) return null;

  const contractGroups = Array.from(typeMap.entries()).map(([type, data]) => ({
    type,
    name: data.name,
    percentages: data.percentages.sort((a, b) => a - b),
  }));

  return (
    <Container>
      <Row>
        <RowLabel>Life Plan Details</RowLabel>
      </Row>
      <LinearGradientDivider></LinearGradientDivider>

      <LabelsRow>
        {contractGroups.map((group) => (
          <Column key={group.type}>
            <Dot />
            <LabelWrapper>
              <Label>{group.name}</Label>
            </LabelWrapper>
          </Column>
        ))}
      </LabelsRow>

      <PercentagesRow>
        {contractGroups.map((group) => (
          <Column key={group.type + '-percent'}>
            <Percentages>{group.percentages.join('%, ')}% refund</Percentages>
          </Column>
        ))}
      </PercentagesRow>
    </Container>
  );
};

export default BasicInfoLifePlanDetails;
